
export default function SmartFacilities() {
  const smartFeatures = [
    {
      icon: 'ri-home-wifi-line',
      title: '스마트 홈 자동화',
      description: '조명, 온도, 보안을 통합 제어하는 AI 기반 홈 시스템'
    },
    {
      icon: 'ri-shield-check-line',
      title: '첨단 보안 시스템',
      description: '얼굴인식, 모바일 출입, 24시간 AI 모니터링'
    },
    {
      icon: 'ri-voice-recognition-line',
      title: '음성 제어',
      description: '음성 명령으로 모든 가전과 시설을 편리하게 제어'
    },
    {
      icon: 'ri-dashboard-line',
      title: '에너지 관리',
      description: '실시간 에너지 사용량 모니터링 및 최적화'
    },
    {
      icon: 'ri-smartphone-line',
      title: '모바일 통합',
      description: '언제 어디서나 스마트폰으로 집안 관리'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24시간 컨시어지',
      description: 'AI 챗봇과 전문 상담원의 통합 서비스'
    }
  ];

  const communityFacilities = [
    {
      name: '프리미엄 피트니스',
      image: 'https://public.readdy.ai/ai/img_res/f8b593fd7614eb4d49d61d10125cf6bd.jpg'
    },
    {
      name: '스카이 라운지',
      image: 'https://readdy.ai/api/search-image?query=elegant%20sky%20lounge%20with%20panoramic%20city%20views%20and%20modern%20furniture%2C%20sophisticated%20rooftop%20lounge%20interior%20with%20comfortable%20seating%20and%20ambient%20lighting%2C%20luxury%20residential%20lounge%20with%20contemporary%20design%20and%20premium%20finishes&width=600&height=400&seq=facility-lounge&orientation=landscape'
    },
    {
      name: '공유 오피스',
      image: 'https://readdy.ai/api/search-image?query=modern%20co-working%20space%20with%20ergonomic%20furniture%20and%20natural%20light%2C%20contemporary%20shared%20office%20interior%20with%20clean%20design%20and%20collaborative%20areas%2C%20professional%20workspace%20with%20minimalist%20aesthetic%20and%20smart%20technology&width=600&height=400&seq=facility-office&orientation=landscape'
    },
    {
      name: '키즈 카페',
      image: 'https://readdy.ai/api/search-image?query=bright%20modern%20kids%20cafe%20with%20colorful%20play%20areas%20and%20safe%20equipment%2C%20contemporary%20children%20play%20space%20with%20clean%20design%20and%20educational%20toys%2C%20family-friendly%20facility%20with%20minimalist%20aesthetic%20and%20natural%20materials&width=600&height=400&seq=facility-kids&orientation=landscape'
    },
    {
      name: '독서 라운지',
      image: 'https://readdy.ai/api/search-image?query=cozy%20reading%20lounge%20with%20comfortable%20seating%20and%20bookshelves%2C%20modern%20library%20space%20with%20warm%20lighting%20and%20minimalist%20design%2C%20quiet%20study%20area%20with%20contemporary%20furniture%20and%20natural%20ambiance&width=600&height=400&seq=facility-library&orientation=landscape'
    },
    {
      name: '게스트 하우스',
      image: 'https://readdy.ai/api/search-image?query=elegant%20guest%20house%20room%20with%20modern%20amenities%20and%20comfortable%20bed%2C%20luxury%20hotel-style%20accommodation%20with%20contemporary%20design%20and%20premium%20finishes%2C%20sophisticated%20guest%20suite%20with%20minimalist%20aesthetic%20and%20natural%20lighting&width=600&height=400&seq=facility-guest&orientation=landscape'
    }
  ];

  return (
    <section id="smart" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">스마트 홈 & 커뮤니티 시설</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            최첨단 스마트 홈 기술과 프리미엄 커뮤니티 시설로<br />
            편리하고 품격있는 라이프스타일을 제공합니다.
          </p>
        </div>

        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">스마트 홈 시스템</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {smartFeatures.map((feature, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-all cursor-pointer group">
                <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-6 group-hover:bg-teal-600 transition-colors">
                  <i className={`${feature.icon} text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h4>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">프리미엄 커뮤니티 시설</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {communityFacilities.map((facility, index) => (
              <div key={index} className="group cursor-pointer">
                <div className="relative h-64 rounded-xl overflow-hidden mb-4 shadow-md group-hover:shadow-xl transition-all">
                  <img 
                    src={facility.image} 
                    alt={facility.name} 
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h4 className="text-xl font-bold text-white">{facility.name}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-teal-50 rounded-2xl p-10 text-center">
          <i className="ri-information-line text-5xl text-teal-600 mb-4"></i>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">공공기여 시설</h3>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            3층과 4층의 스마트 시설은 <strong className="text-teal-600">주민 누구에게나 개방</strong>되어 있습니다.<br />
            지역사회와 함께 성장하는 공공기여형 개발로 모두가 누릴 수 있는 프리미엄 시설을 제공합니다.
          </p>
        </div>
      </div>
    </section>
  );
}
